import React from 'react';
import styles from './ProgressBar.module.css';

const ProgressBar = ({ steps, currentStep }) => {
  const completed = steps.filter(s => s.completed).length;
  const total = steps.length;
  const percentage = total > 0 ? (completed / total) * 100 : 0;

  const getStepIcon = (isCompleted, isCurrent) => {
    if (isCompleted) return 'DONE';
    if (isCurrent) return 'ACTIVE';
    return 'PENDING';
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>
          Progress: {completed}/{total} Steps ({Math.round(percentage)}%)
        </span>
      </div>

      <div className={styles.barContainer}>
        <div className={styles.bar} style={{ width: `${percentage}%` }} />
      </div>

      <div className={styles.steps}>
        {steps.map((item) => {
          const isCurrent = item.step === currentStep;
          const isCompleted = item.completed;
          const icon = getStepIcon(isCompleted, isCurrent);

          return (
            <div
              key={item.step}
              className={`${styles.step} ${
                isCurrent ? styles.current : ''
              } ${isCompleted ? styles.completed : ''}`}
            >
              <div className={styles.icon}>
                <span className={styles.iconText}>{icon}</span>
              </div>
              <div className={styles.name}>{item.info.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
